// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function notifyVueObserver(object) {
    if (!object) {
        return;
    }
    if (object.__ob__) {
        object.__ob__.dep.notify();
    }
}
